module.exports = __webpack_public_path__ + "img/filter.805998c5.svg";